<template>
    <div class="af" >
        <div class="flex alc" id="toolH">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="$t('invoiceEntry_please_enter_order_number/product_name_to_search')" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                height="385"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @selection-change="handleSelectionChange"
                @select="select"

                :row-key="getRowKeys"
                :default-expand-all="expend"
        >
            <!--row-key="i_id"-->
            <el-table-column
                    align="center"
                    type="selection"
                    :selectable="isRowSelectable"
                    :reserve-selection="true">
            </el-table-column>
            <el-table-column
                    align="center"
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="i_id"
                    :label="$t('invoiceEntry_payment_application_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="f_num"
                    :label="$t('form_quantity')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="f_sqpay_total"
                    :label="$t('invoiceEntry_total_amount_applied_for')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.f_sqpay_total+scope.row.vc_bzsymbol}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="expand"
                    :label="$t('form_variety')"
                    show-overflow-tooltip>
                <template slot-scope="props">
                    <el-table
                            border
                            :data="props.row.details"
                            class="child-table"
                            style="width: 100%"
                            :header-cell-style="{background:'#eef1f6',color:'grey'}"

                    >
                        <!--:show-header="false"-->
                        <el-table-column
                                prop="vc_pzname"
                                :label="$t('form_product_name')"
                                show-overflow-tooltip
                                width="360"
                                align="left">
                            <template slot-scope="scope">
                                <span>{{scope.row.vc_pzname==null?'-':scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="f_price_yb"
                                :label="$t('form_unit_price')"
                                show-overflow-tooltip
                                align="left">
                        </el-table-column>
                        <el-table-column
                                prop="f_num"
                                :label="$t('invoiceEntry_order_volume')"
                                show-overflow-tooltip
                                align="left">
                        </el-table-column>
                        <el-table-column
                                prop="f_num_rk"
                                :label="$t('invoiceEntry_inbound_quantity')"
                                show-overflow-tooltip
                                align="left">
                        </el-table-column>
                        <el-table-column
                                prop="f_fpnum"
                                :label="$t('invoiceEntry_invoiced_quantity')"
                                show-overflow-tooltip
                                align="left">
                        </el-table-column>
                        <el-table-column
                                prop="f_sqje"
                                :label="$t('invoiceEntry_payment_application_amount')"
                                show-overflow-tooltip
                                align="left">
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <!--<el-table-column
                    align="center"
                    prop="i_over"
                    :label="$t('form_state')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span :class="(scope.row.i_over==0)?'red':'green'">{{scope.row.i_over==0?'执行中':(scope.row.i_over==1?'已关闭':'')}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="60"
                    :label="$t('form_operate')">
                <template slot-scope="scope" v-if="scope.row.i_over==0">
                    <el-button  type="text" size="small" @click="closeDd(scope.row)">关闭</el-button>
                </template>
            </el-table-column>-->
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {},
        props: {
            dataOrd: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                loading:false,
                dt_startdate:'',
                dt_enddate:'',
                vc_search:"",
                valuetime:'',
                getRowKeys(row){
                    return row.i_id
                },
                baseerp: "",
                mid: 0,
                expend:false,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                pageSize: 30,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        mounted() {
            //this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("dataOrd", this.dataOrd);
            this.getOrders();
            this.baseerp = baseerp;
        },
        methods: {
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.currentPage=1;
                this.tableData=[];
                this.getOrders();
            },
            /*closeDd(row){
                this.closeOrder(row);
            },*/
            //关闭订单
           /* async closeOrder(row){
                let param = {
                    i_id:row.i_id,
                };
                let res = await API.closeOrder(param);
                if(res.code == 0){
                    let i_type=res.data.i_type;
                    if(i_type==1){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>{{$t('invoiceEntry_exception_type')}}：${item.vc_type}</li>
                                    <li>异常品名：${item.vc_paname}</li>
                                    <li>异常数量：${item.f_lossnum}</li>
                                    <li>收发货安排单号：${item.vc_code}</li>
                                    <li>车号：${item.vc_carno}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_complete_the_exception_approval'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if(i_type==2){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>运输单号：${item.vc_code}</li>
                                    <li>运输公司：${item.vc_yskhname}</li>
                                    <li>品名：${item.vc_paname}</li>
                                    <li>数量：${item.f_num}</li>
                                    <li>未执行量：${item.f_nosend}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_contact_the_logistics_to_terminate_the_transportation_agreement'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if( i_type==3){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>收发货安排单号：${item.vc_code}</li>
                                    <li>车号：${item.vc_carno}</li>
                                    <li>司机信息：${item.vc_tran_name+item.vc_tran_tel}</li>
                                    <li>品名：${item.vc_paname}</li>
                                    <li>数量：${item.f_num}</li>
                                    <li>未执行量:${item.f_onconfirm}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_contact_the_logistics_for_cancellation_or_contact_the_warehouse_to_confirm_receipt'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }
                } else if (res.code == 1) {
                    this.currentPage=1;
                    this.tableData=[];
                    this.tableTotal=0;
                    this.getOrders();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },*/
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            isRowSelectable(row,index){
               if(row.disabled){
                   return false
               }else{
                   return true
               }
            },
            select(val,row){
                /*if(this.dataOrd.i_flag==1){
                    if(val.length>1){
                        let idx = this.tableData.findIndex(item=>(item.i_id == row.i_id));
                        this.$refs.table.toggleRowSelection(this.tableData[idx],false)
                        this.$message.error(this.$t('invoiceEntry_only_one_order_can_be_selected_from_the_import_tax_bill_and_import_invoice'));
                        val.pop();
                        return;
                    }
                }else{
                    let arr = val.filter(item => {
                        return item.i_over == 0
                    });
                    let arrlen = arr.length;
                    console.log(arrlen,'arrlen11111');
                    if(arrlen>1){
                        let idx = this.tableData.findIndex(item=>(item.i_id == row.i_id));
                        this.$refs.table.toggleRowSelection(this.tableData[idx],false)
                        this.$message.error(this.$t('invoiceEntry_only_one_order_can_be_selected_during_execution'));
                        val.pop();
                        //return;
                    }
                }
                console.log(val,'vallllllll')*/
            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                //console.log(this.multipleSelection,'vallllllll')
            },
            // 查询付款申请
            async getOrders(){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    'i_id':this.dataOrd.i_id,
                    'i_kpkhid':this.dataOrd.i_kpkhid,
                    'i_gsid':this.dataOrd.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_fymx':this.dataOrd.vc_fymx,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    'vc_search':this.vc_search,
                };
                let res = await API.fksq(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData = res.data.list;
                    this.tableTotal = res.data.total;

                    //console.log(this.tableData);
                    this.$nextTick(()=>{
                        for(let i=0;i<this.tableData.length;i++){
                            let pz= this.tableData[i];
                            for(let s of this.dataOrd.selected){
                                if(pz.i_id==s){
                                    this.$refs.table.toggleRowSelection(this.tableData[i],true)
                                }
                            }
                            for(let s of this.dataOrd.disselect){
                                if(pz.i_id==s){
                                    //pz.disabled=true;
                                    this.$refs.table.toggleRowSelection(this.tableData[i],true)
                                }
                            }
                        }
                        if(res.data.total==1){
                            this.expend=true;
                            this.refreshTable()
                        }
                    });

                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getOrders();
            },

            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders();
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders();
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            //保存
            async saveForm(){
                //console.log('this.multipleSelection',this.multipleSelection)
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_an_order'));
                }else{
                    let orderWs='';
                    let arr = [];
                    let ids = [];
                    this.multipleSelection.map(item=>{
                        arr.push(item.i_id)
                        ids.push(item.i_id)
                    });
                    //console.log(arr,'arr')
                    orderWs=arr.toString();
                    //console.log(orderWs,'orderws')
                    let map={
                        orderWs:orderWs,
                        ids:ids,
                        //details:this.dataOrd.i_flag==1?this.multipleSelection[0].details:null,
                        details:this.multipleSelection,
                        i_bzid_yb:this.multipleSelection[0].i_bzid_yb
                    }
                    this.$emit('cancelDialog_order',map)
                    /*let arr = this.multipleSelection.filter(item => {
                        return item.i_over == 0
                    });
                    let arrlen = arr.length;
                    console.log(arrlen,'arrlen');
                    if(arrlen>1){
                        this.$message.error(this.$t('invoiceEntry_only_one_order_can_be_selected_during_execution_if_multiple_selections_are_required_please_close_any_orders_that_will_not_be_executed_in_the_future'));
                        return;
                    }else{
                        //判断是否只有禁用的
                        //let alldis = this.multipleSelection.every(item=>{
                        //    return item.disabled==true
                        //})
                        //console.log('alldis',alldis)
                        //if(alldis){
                        //    this.cancel()
                        //}else{
                            let orderWs='';
                            let arr = [];
                            let ids = [];
                            this.multipleSelection.map(item=>{
                                arr.push(item.vc_no)
                                ids.push(item.vc_no)
                            });
                            console.log(arr,'arr')
                            orderWs=arr.toString();
                            console.log(orderWs,'orderws')
                            let map={
                                orderWs:orderWs,
                                ids:ids,
                                details:this.dataOrd.i_flag==1?this.multipleSelection[0].details:null,
                                i_bzid_yb:this.multipleSelection[0].i_bzid_yb
                            }
                            this.$emit('cancelDialog_order',map)
                        //}
                    }*/
                }
            },
            cancel(){
                this.$emit('cancelDialog_order');
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>

    /deep/ .el-table th{
            //text-align: left !important;
        }

    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
